import PublicIcon from "@mui/icons-material/Public";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { UpAndDownButton } from "components/shared/UpAndDown";
import Highlight from "components/ui/atoms/Highlight";
import GoogleDriveIcon from "components/ui/icons/googleDrive.svg";
import { CopyToClipboard } from "components/ui/atoms/CopyToClipboard";
import CompanyWatcher from "../company_watchers/CompanyWatcher";
import SlackLink from "components/ui/atoms/SlackLink";
import FormHeader from "components/ui/atoms/FormHeader";

const CreateFormHeader = ({}) => {
  const theme = useTheme();

  return <Highlight color={theme.palette_custom.yellow}>Create deal</Highlight>;
};

const UpdateFormHeader = ({ deal }) => {
  const theme = useTheme();

  return (
    <>
      <UpAndDownButton value={deal.id} />
      <CopyToClipboard
        text={
          new URL(`/company/${deal.company_detail.id}/`, document.baseURI).href
        }
      />
      <Stack sx={{ ml: 1 }}>
        <Highlight color={theme.palette_custom.yellow}>
          <Link to={`/company/${deal.company_detail.id}/`}>
            {deal.company_detail?.best_name}
          </Link>
        </Highlight>
        <Typography variant="caption">
          {`Created at ${new Date(
            Date.parse(deal.created_at),
          ).toLocaleDateString()}`}
        </Typography>
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          ml: "auto",
        }}
      >
        <CompanyWatcher companyId={deal.company_detail.id} />
        <SlackLink slack_channel_id={deal.company_detail.slack_channel_id} />
        <a href={`https://${deal.company_detail?.best_domain}`} target="_blank">
          <IconButton>
            <PublicIcon />
          </IconButton>
        </a>
        {deal.company_detail?.link_drive && (
          <a href={`${deal.company_detail.link_drive}`} target="_blank">
            <IconButton>
              <Box>
                <img src={GoogleDriveIcon} width={22} height={22} />
              </Box>
            </IconButton>
          </a>
        )}
      </Box>
    </>
  );
};

const DealFormHeader = ({ formType, onClose, ...props }) => {
  let header;
  if (formType == "create") header = <CreateFormHeader {...props} />;
  if (formType == "update") header = <UpdateFormHeader {...props} />;

  return <FormHeader onClose={onClose}>{header}</FormHeader>;
};

export default DealFormHeader;
